/* 证书查询接口 */
import { axios } from '@/utils/http'

// 证书查询接口 - 使用真实后端接口
export const searchCertificate = (params) => {
  return axios({
    method: 'GET',
    contentType: 'urlencoded',
    noToast: true,
    hastoken: true,
    baseURL: process.env.VUE_ENV === 'server' ? process.env.VUE_APP_BASE_URL : '/api'
  }, `/certificates/getCertificatesByCodeAndName?certificateNumber=${params.certificateNumber}&recipientName=${params.name}`)
    .then(res => {
      console.log('证书查询响应:', res)

      if (res.success && res.result) {
        // 适配数据结构 - 统一转换为组件期望的格式
        const certificate = {
          id: res.result.id,
          name: res.result.recipientName,
          certificateNumber: res.result.certificateNumber,
          title: res.result.title,
          description: res.result.description,
          awardDate: res.result.awardDate,
          issuer: res.result.issuer,
          // 预览使用图片，如果没有图片则使用PDF
          type: res.result.previewImageUrl ? 'image' : 'pdf',
          url: res.result.previewImageUrl || res.result.pdfUrl, // 预览URL
          pdfUrl: res.result.pdfUrl, // PDF下载URL
          previewImageUrl: res.result.previewImageUrl // 预览图片URL
        }

        return {
          code: 200,
          data: certificate,
          message: '查询成功'
        }
      } else {
        return {
          code: 404,
          data: null,
          message: res.message || '未找到相关证书'
        }
      }
    })
    .catch(error => {
      console.error('证书查询失败:', error)
      return {
        code: 500,
        data: null,
        message: '查询失败，请稍后重试'
      }
    })
}

// 证书真伪验证接口
export const verifyCertificate = (params) => {
  return axios({
    method: 'GET',
    contentType: 'urlencoded',
    noToast: true,
    hastoken: true,
    baseURL: process.env.VUE_ENV === 'server' ? process.env.VUE_APP_BASE_URL : '/api'
  }, `/certificates/verifyCertificate?certificateNumber=${params.certificateNumber}&recipientName=${params.name}`)
    .then(res => {
      console.log('证书验证响应:', res)

      if (res.success) {
        return {
          code: 200,
          data: {
            isValid: res.result
          },
          message: res.result ? '验证成功' : '验证失败'
        }
      } else {
        return {
          code: 500,
          data: {
            isValid: false
          },
          message: res.message || '验证失败'
        }
      }
    })
    .catch(error => {
      console.error('证书验证失败:', error)
      return {
        code: 500,
        data: {
          isValid: false
        },
        message: '验证失败，请稍后重试'
      }
    })
}
